<template>
  <v-menu
    offset-y
    right
    transition="slide-y-transition"
    :close-on-content-click="false"
    v-model="menu"
    full-width
    :max-width="540"
    :nudge-right="300"
    content-class="mongo-datatable-filter-container"
  >
    <v-btn slot="activator" flat icon class="btn-toolbar">
      <v-badge v-model="isFilter" overlap color="orange">
        <span slot="badge">{{ (value || []).length }}</span>
        <v-icon>search</v-icon>
      </v-badge>
    </v-btn>
    <v-card class="mongo-datatable-filter">
      <v-toolbar color="white" class="elevation-0">
        <span class="headline">Filter</span>
        <v-btn color="pink" dark small absolute bottom right fab
          :disabled="flatSchemaArray.length === 0"
          @click="addNewFilter"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <div v-if="filters.length === 0" class="subheading grey lighten-5 text-xs-center pa-3" style="min-width: 369px">
        No filtered
      </div>
      <v-form v-else ref="form" v-model="formValid" @submit.prevent="submit()">
        <v-list three-line class="grey lighten-5 pb-0 pt-3">
          <template v-for="(filterObj, i) in filters">
            <v-list-tile :key="filterObj._id">
              <v-list-tile-content>
                <v-container fluid pa-0 d-flex align-center>
                  <v-layout row wrap style="align-items: flex-start">
                    <v-flex xs2 md1 class="text-xs-center" style="align-self: center">
                      <v-btn flat icon class="btn-toolbar ma-0 pa-0" color="pink"
                        @click="removeFilter(filterObj)"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3 md4 class="text-xs-center">
                      <v-select
                        v-model="filterObj['field']"
                        :items="fieldNames"
                        item-text="label"
                        item-value="key"
                        label="Field"
                        single-line
                        class="text-single-line"
                        @change="field => selectOperator(filterObj, field, 0)"
                      ></v-select>
                    </v-flex>
                    <v-flex xs3 md3 class="text-xs-center">
                      <v-select
                        v-model="filterObj['comparison']"
                        :items="getOperators(filterObj['field'])"
                        item-text="label"
                        item-value="type"
                        return-object
                        label="Field"
                        single-line
                        class="text-single-line"
                        :style="{ 'font-weight': 'bold' }"
                      ></v-select>
                    </v-flex>
                    <v-flex
                      :class="[
                        'text-xs-center',
                        Array.isArray(flatSchema[filterObj['field']].type) ? 'xs12' : 'xs4 md4'
                      ]">
                      <MongoField
                        v-model="filterObj['value']"
                        :propSchema="flatSchema[filterObj['field']]"
                        :rules="undefined /* formRules[filterObj['field']] */"
                        placeholder="empty"

                        :label="undefined"
                        :expand="true"
                        :flat="false"
                        @keydown.enter.prevent.native="submit()"
                      />
                    </v-flex>
                    <template v-if="i !== 0">
                      <v-btn @click="toggleFilterLogical(filterObj, 'logical')"
                        :color="getFilterLogicalColor(filterObj['logical'])"
                        dark small absolute top center fab style="left: 50%; margin-left: -20px;">
                        {{ filterObj['logical'].label }}
                      </v-btn>
                    </template>
                  </v-layout>
                </v-container>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider :key="`divider-${filterObj._id}`"></v-divider>
          </template>
        </v-list>
      </v-form>
      <!-- <v-card-text class="grey lighten-5 px-3 py-5">
        <template v-for="i in 2">
          <v-container :key="`c_${i}`" grid-list-md text-xs-center class="elevation-1">
            <v-layout row wrap>
              <v-flex xs12>
                Test
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider :key="`d_${i}`"></v-divider>
        </template>
      </v-card-text> -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="close">Close</v-btn>
        <v-btn color="primary darken-1" flat @click="clear">Clear</v-btn>
        <v-btn color="primary" dark @click="submit">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import MongoField from './MongoField'
  import { objectToArray, titleText } from '../../libs/utils'
  import { getFilterableOperatorsByType, getDefaultPropValue, getTableRules, createFilterableObject, FILTER_LOGICAL_OPERATORS } from '../../libs/mongo-datatable'
  import { createMongooseSchema } from '../../services/mongo-connector.service'

  export default {
    props: {
      value: { type: Array, required: false, default: () => [] },
      flatSchema: { type: Object, required: true }
    },
    data () {
      return {
        menu: false,
        defaultFilters: [],
        filters: [],
        form: {},
        formValid: true
        // formRules: {}
      }
    },
    computed: {
      flatSchemaArray () {
        return objectToArray(this.flatSchema)
      },
      fieldNames () {
        return Object.keys(this.flatSchema)
          // FIXME: Enable Array Schema Type by remove below filter
          .filter(key => {
            return !Array.isArray(this.flatSchema[key].type)
          })
          .map(key => ({
            key,
            label: titleText(key)
          }))
      },
      isFilter () {
        return (this.value || []).length > 0
      }
    },
    watch: {
      menu (isShow) {
        if (isShow) {
          this.defaultFilters = this.value.map(x => ({...x}))
          this.reset()
        }
      }
      // filters: {
      //   deep: true,
      //   handler (columns) {
      //     // this.form = columns.reduce((c, column) => {
      //     //   c[column.field] = column.value
      //     //   return c
      //     // }, {})
      //     // this.formRules = getTableRules(
      //     //   this.form,
      //     //   this.flatSchema,
      //     //   createMongooseSchema(this.flatSchema)
      //     // )
      //   }
      // }
    },
    methods: {
      reset () {
        if (this.defaultFilters.length > 0) {
          this.filters = this.defaultFilters.map(x => ({...x, value: undefined}))
          this.$nextTick(() => {
            this.filters.forEach((column, i) => {
              column['value'] = this.defaultFilters[i]['value']
            })
          })
        } else {
          this.clear()
        }
      },
      addNewFilter () {
        if (!this.flatSchemaArray.length) return
        const { key, value: propSchema } = this.flatSchemaArray[0]
        this.filters.push(
          createFilterableObject(
            key,
            getFilterableOperatorsByType(propSchema.type)[0],
            getDefaultPropValue(propSchema)
          )
        )
      },
      removeFilter (filter) {
        const index = this.filters.indexOf(filter)
        this.filters.splice(index, 1)
      },
      getOperators (field) {
        const { type } = this.flatSchema[field]
        return getFilterableOperatorsByType(type).map(item => {
          return {
            ...item
          }
        })
      },
      selectOperator (filterObj, field, index) {
        filterObj.comparison = this.getOperators(field)[index]
      },
      clear () {
        this.filters = []
      },
      close () {
        this.menu = false
      },
      submit () {
        const valid = this.$refs.form === undefined || this.$refs.form.validate()
        console.log('formValid', valid)
        if (valid) {
          this.menu = false
          this.$emit('input', this.filters)
          this.$emit('submit', this.filters)
        }
      },
      toggleFilterLogical (obj, key) {
        obj[key] = obj[key].type === FILTER_LOGICAL_OPERATORS.AND.type
          ? FILTER_LOGICAL_OPERATORS.OR
          : FILTER_LOGICAL_OPERATORS.AND
      },
      getFilterLogicalColor (logical) {
        return logical.type === FILTER_LOGICAL_OPERATORS.AND.type ? 'blue darken-2' : 'green darken-2'
      },
      createMongooseRules () {
        const flatSchema = {}
        this.filters.forEach((column, i) => {
          flatSchema[i] = this.flatSchema[column['field']]
        })
        this.formRules = getTableRules(
          this.form,
          createMongooseSchema(flatSchema)
        )
      }
    },
    components: {
      MongoField
    }
  }
</script>

<style lang="scss" scoped>
  .text-single-line {
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>

<style lang="scss">
  .mongo-datatable-filter-container {
    width: 100%;
    .mongo-datatable-filter {
      .list__tile {
        padding: 0;
        height: auto;
      }
    }
  }
</style>

